import { isEmpty } from 'lodash';
import { createAction } from 'redux-actions';
import { EVERIFY_TEST_MODES } from '../../../settings/settings';
import { callApi, getEndpoint } from '../../../utils/api';
import {
  validateExactLength,
  validateExactValue,
  validateMaxLength,
  validateRequired,
} from '../../../utils/form/validate/validate';
import { coalesce } from '../../../utils/utils';
import settings from 'src/settings/settings';

const EVERIFY_ATTEMPT = 'EVERIFY_ATTEMPT';
const EVERIFY_NOTIFICATION = 'EVERIFY_NOTIFICATION';
const EVERIFY_REQUEST = 'EVERIFY_REQUEST';
const EVERIFY_RESULT = 'EVERIFY_RESULT';
const EVERIFY_CHECK_STATUS = 'EVERIFY_CHECK_STATUS';
const EVERIFY_ADD_BANK = 'EVERIFY_ADD_BANK';
const EVERIFY_RESET = 'EVERIFY_RESET';
const EVERIFY_FAILURE = 'FAILED';
const UPDATE_MANUAL_BANK_FIELD = 'UPDATE_MANUAL_BANK_FIELD';
const CREATE_EVERIFY = 'CREATE_EVERIFY';
export const RETREIVE_FAILURE_HISTORY = 'RETREIVE_FAILURE_HISTORY';
const VALIDATE_ROUTING_NUMBER = 'VALIDATE_ROUTING_NUMBER';
const SET_COOKIES_TRUE = 'SET_COOKIES_TRUE';
const RESET_VALIDATE_ROUTING_NUMBER = 'RESET_VALIDATE_ROUTING_NUMBER';

const initialState = {
  trackingid: '',
  uberId: '',
  userId: '',
  cookieSet: false,
  checkStatus: null,
  verifiedBank: false,
  bankAwaitingVerification: false,
  checkStatusLoading: false,
  checkStatusLoaded: false,
  checkStatusFailed: false,
  addBankStatus: null,
  addBankLoaded: false,
  addBankLoading: false,
  addBankFailed: false,
  attempts: 0,
  evyReady: false,
  evrFailed: false,
  failureHistory: null,
  hasFailed: false,
  historyLoaded: false,
  historyLoading: false,
  manualBankAccountNumber: '',
  manualBankAccountNumberError: '',
  manualBankAccountNumberTouched: false,
  manualBankAccountType: '',
  manualBankAccountTypeError: '',
  manualBankAccountTypeTouched: false,
  manualBankAgreementConsent: false,
  manualBankAgreementConsentError: '',
  manualBankAgreementConsentTouched: false,
  manualBankJointOwnerFirstName: '',
  manualBankJointOwnerLastName: '',
  manualBankJointOwnerSuffix: '',
  manualBankOwner: '',
  manualBankReady: false,
  manualBankRoutingNumber: '',
  manualBankRoutingNumberError: '',
  manualBankRoutingNumberTouched: false,
  manualBankSimulationMode: EVERIFY_TEST_MODES.PASSED,
  notificationLoading: false,
  requestLoaded: false,
  requestLoading: false,
  resultLoading: false,
  resultLoaded: false,
  resultType: null,
  test: false,
  trackingID: null,
  token: null,
  res: null,
  status: 'INIT',
  xml: null,
};

function validateManualBank(state) {
  const {
    manualBankAccountNumber,
    manualBankAccountNumberTouched,
    manualBankAccountType,
    manualBankAccountTypeTouched,
    manualBankAgreementConsent,
    manualBankAgreementConsentTouched,
    manualBankRoutingNumber,
    manualBankRoutingNumberTouched,
  } = state;

  const manualBankAgreementConsentError =
    (state.manualBankAgreementConsentError = validateExactValue(
      manualBankAgreementConsent,
      true,
      manualBankAgreementConsentTouched,
      'Required'
    ));

  const manualBankAccountNumberError = (state.manualBankAccountNumberError =
    validateRequired(manualBankAccountNumber, manualBankAccountNumberTouched) ||
    validateMaxLength(
      manualBankAccountNumber,
      17,
      manualBankAccountNumberTouched,
      'Invalid Bank Account Number'
    ));

  const manualBankAccountTypeError = (state.manualBankAccountTypeError =
    validateRequired(manualBankAccountType, manualBankAccountTypeTouched));

  const manualBankRoutingNumberError = (state.manualBankRoutingNumberError =
    validateRequired(manualBankRoutingNumber, manualBankRoutingNumberTouched) ||
    validateExactLength(
      manualBankRoutingNumber,
      9,
      manualBankRoutingNumberTouched,
      'Invalid Routing Number'
    ));

  state.manualBankReady =
    manualBankAgreementConsentTouched &&
    manualBankAccountNumberTouched &&
    manualBankAccountTypeTouched &&
    manualBankRoutingNumberTouched &&
    !manualBankAgreementConsentError &&
    !manualBankAccountNumberError &&
    !manualBankAccountTypeError &&
    !manualBankRoutingNumberError;

  return state;
}

export default function eVerification(
  state = { attempts: 0, ...initialState },
  { payload, type }
) {
  switch (type) {
    case `${CREATE_EVERIFY}_PENDING`:
      return {
        ...state,
        evyReady: false,
        evrFailed: false,
      };
    case `${CREATE_EVERIFY}_FULFILLED`:
      return {
        ...state,
        trackingid: payload.body.trackingid,
        evyReady: true,
        evrFailed: false,
      };
    case `${CREATE_EVERIFY}_REJECTED`:
      return {
        ...state,
        evyReady: false,
        evrFailed: true,
      };
    case `${EVERIFY_REQUEST}_PENDING`:
      return {
        ...state,
        requestLoading: true,
      };
    case `${EVERIFY_REQUEST}_FULFILLED`:
      return {
        ...state,
        status: 'REQUEST SUCCESSFUL',
        requestLoaded: true,
        token: payload.body.token,
        xml: payload.body.encrptyedXML,
        requestLoading: false,
      };
    case `${EVERIFY_REQUEST}_REJECTED`:
      return {
        ...state,
        hasFailed: true,
        requestLoaded: true,
        requestLoading: false,
      };
    case `${EVERIFY_NOTIFICATION}_PENDING`:
      return {
        ...state,
        notificationLoading: true,
      };
    case `${EVERIFY_NOTIFICATION}_FULFILLED`:
      return {
        ...state,
        status: 'NOTIFICATION SUCCESSFUL',
      };
    case `${EVERIFY_NOTIFICATION}_REJECTED`:
      return {
        ...state,
        hasFailed: true,
      };
    case `${EVERIFY_RESULT}_PENDING`:
      return {
        ...state,
        resultLoading: true,
      };
    case `${EVERIFY_RESULT}_FULFILLED`:
      if (payload.body && payload.statusCode === 200) {
        return {
          ...state,
          resultLoading: false,
          resultLoaded: true,
          attempts: state.attempts + 1,
          status: coalesce(
            payload.body.verificationResultType,
            EVERIFY_FAILURE
          ),
          trackingID: coalesce(payload.body.trackingID, ''),
          resultType: coalesce(
            payload.body.verificationResultType,
            EVERIFY_FAILURE
          ),
        };
      }
      return state;
    case `${EVERIFY_RESULT}_REJECTED`:
      return {
        ...state,
        hasFailed: true,
        resultType: EVERIFY_FAILURE,
        resultLoading: false,
      };
    case `${EVERIFY_CHECK_STATUS}_PENDING`:
      return {
        ...state,
        checkStatusLoading: true,
      };
    case `${EVERIFY_CHECK_STATUS}_FULFILLED`:
      return {
        ...state,
        checkStatus: payload.body.bankVerificationStatus?.enumerationID || null,
        verifiedBank: payload.body.verifiedBank,
        bankAwaitingVerification: payload.body.bankAwaitingVerification,
        checkStatusLoaded: true,
        checkStatusLoading: false,
      };
    case `${EVERIFY_CHECK_STATUS}_REJECTED`:
      return {
        ...state,
        checkStatusFailed: true,
        checkStatusLoaded: true,
        checkStatusLoading: false,
      };
    case `${EVERIFY_ADD_BANK}_PENDING`:
      return {
        ...state,
        addBankLoading: true,
      };
    case `${EVERIFY_ADD_BANK}_FULFILLED`:
      return {
        ...state,
        addBankStatus: payload.body.bankAdditionSuccess ? 'SUCCESS' : 'FAILED',
        addBankLoaded: true,
        addBankLoading: false,
      };
    case `${EVERIFY_ADD_BANK}_REJECTED`:
      return {
        ...state,
        addBankStatus: 'FAILED',
        addBankFailed: true,
        addBankLoaded: true,
        addBankLoading: false,
      };
    case `${EVERIFY_ATTEMPT}_FULFILLED`:
      return {
        ...state,
        attempts: state.attempts + 1,
      };
    case `${EVERIFY_RESET}_FULFILLED`:
      return {
        ...initialState,
        attempts: state.attempts,
        evrFailed: false,
        manualBankAccountNumber: '',
        manualBankAccountNumberError: '',
        manualBankAccountNumberTouched: false,
        manualBankAccountType: '',
        manualBankAccountTypeError: '',
        manualBankAccountTypeTouched: false,
        manualBankAgreementConsent: false,
        manualBankAgreementConsentError: '',
        manualBankAgreementConsentTouched: false,
        manualBankJointOwnerFirstName: '',
        manualBankJointOwnerLastName: '',
        manualBankJointOwnerSuffix: '',
        manualBankOwner: '',
        manualBankReady: false,
        manualBankRoutingNumber: '',
        manualBankRoutingNumberError: '',
        manualBankRoutingNumberTouched: false,
        manualBankSimulationMode: EVERIFY_TEST_MODES.PASSED,
      };
    case SET_COOKIES_TRUE:
      return validateManualBank({
        ...state,
        cookieSet: true,
      });
    case UPDATE_MANUAL_BANK_FIELD:
      return validateManualBank({
        ...state,
        ...payload,
      });
    case RESET_VALIDATE_ROUTING_NUMBER:
      return {
        ...state,
        routingValidationLoading: false,
        routingValidationLoaded: false,
        routingValid: false,
        manualBankRoutingNumberError: 'Invalid Routing Number',
      };
    case `${VALIDATE_ROUTING_NUMBER}_PENDING`:
      return {
        ...state,
        routingValidationLoading: true,
        routingValidationLoaded: false,
        routingValid: false,
        manualBankRoutingNumberError: 'Validating Routing Number',
      };
    case `${VALIDATE_ROUTING_NUMBER}_REJECTED`:
      return {
        ...state,
        routingValidationLoading: false,
        routingValidationLoaded: true,
        routingValid: false,
        manualBankRoutingNumberError: 'Invalid Routing Number',
      };
    case `${VALIDATE_ROUTING_NUMBER}_FULFILLED`: {
      return {
        ...state,
        routingValidationLoading: false,
        routingValidationLoaded: true,
        routingValid: true,
        manualBankRoutingNumberError: 'Valid Routing Number',
      };
    }
    case `${RETREIVE_FAILURE_HISTORY}_PENDING`:
      return {
        ...state,
        historyLoading: true,
      };
    case `${RETREIVE_FAILURE_HISTORY}_REJECTED`:
      return {
        ...state,
        historyLoaded: true,
        historyFailed: true,
        historyLoading: false,
      };
    case `${RETREIVE_FAILURE_HISTORY}_FULFILLED`: {
      const { everifyFailureHistory: { bankFailureEventList = [] } = {} } =
        payload.body || {};
      return {
        ...state,
        historyLoaded: true,
        historyLoading: false,
        attempts: state.attempts + (bankFailureEventList.length || 0),
      };
    }
    default:
      return state;
  }
}
///${coalesce(mode, '')
export const makeEverifyRequest = (mode) => {
  return (dispatch) => {
    const action = createAction(EVERIFY_REQUEST)(
      callApi(
        `${getEndpoint('sseVerify')}${mode ? `/stage?mode=${mode}` : '/'}`
      ),
      { method: 'GET' }
    );
    dispatch(action);
  };
};

export const createEverify = (mode) => {
  return (dispatch) => {
    const action = createAction(CREATE_EVERIFY)(
      callApi(
        `${getEndpoint('createEVerify')}${
          !settings.isProd ? `/stage?mode=${mode}` : ''
        }`
      )
    );
    dispatch(action);
  };
};

export const eVerifyPoll = (token) => {
  return (dispatch) => {
    const action = createAction(EVERIFY_RESULT)(
      callApi(`${getEndpoint('eVerify')}/everify-result/${token}`)
    );
    dispatch(action);
  };
};

export const checkStatus = (
  acctType,
  routingNumber,
  accountNumber,
  token,
  fullName
) => {
  const bankData = {
    bankDto: {
      bankAccountType: acctType,
      accountNumber: accountNumber,
      routingNumber: routingNumber,
    },
    token: token,
  };

  // if fullName is empty we will omit bankAccountOwners
  if (!isEmpty(fullName)) {
    bankData.bankAccountOwners = [fullName];
  }
  return (dispatch) => {
    const action = createAction(EVERIFY_CHECK_STATUS)(
      callApi(
        getEndpoint('checkStatus'),
        { method: 'POST' },
        JSON.stringify(bankData)
      )
    );
    dispatch(action);
  };
};

export const addBank = (
  acctType,
  routingNumber,
  accountNumber,
  token,
  fullName
) => {
  const bankData = {
    bankDto: {
      bankAccountType: acctType,
      accountNumber: accountNumber,
      routingNumber: routingNumber,
    },
    token: token,
  };

  // if fullName is empty we will omit bankAccountOwners
  if (!isEmpty(fullName)) {
    bankData.bankAccountOwners = [fullName];
  }

  return (dispatch) => {
    const action = createAction(EVERIFY_ADD_BANK)(
      callApi(
        getEndpoint('addBank'),
        { method: 'POST' },
        JSON.stringify(bankData)
      )
    );
    dispatch(action);
  };
};

export const incrementEverifyAttempts = () => {
  return (dispatch) => {
    const action = createAction(`${EVERIFY_ATTEMPT}_FULFILLED`)(null);
    dispatch(action);
  };
};

export const resetEverify = () => {
  return (dispatch) => {
    const action = createAction(`${EVERIFY_RESET}_FULFILLED`)(null);
    dispatch(action);
  };
};

export const setCookies = () => {
  return (dispatch) => {
    const action = createAction(SET_COOKIES_TRUE)();
    dispatch(action);
  };
};

export const updateManualBankAccountNumber = (manualBankAccountNumber) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankAccountNumber,
    manualBankAccountNumberTouched: true,
  });

export const updateManualBankAccountType = (manualBankAccountType) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankAccountType,
    manualBankAccountTypeTouched: true,
  });

export const updateManualBankAgreementConsent = (manualBankAgreementConsent) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankAgreementConsent,
    manualBankAgreementConsentTouched: true,
  });

export const updateManualBankJointOwnerFirstName = (
  manualBankJointOwnerFirstName
) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankJointOwnerFirstName,
  });

export const updateManualBankJointOwnerLastName = (
  manualBankJointOwnerLastName
) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankJointOwnerLastName,
  });

export const updateManualBankJointOwnerSuffix = (manualBankJointOwnerSuffix) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankJointOwnerSuffix,
  });

export const updateManualBankOwner = (manualBankOwner) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankOwner,
  });

export const updateManualBankRoutingNumber = (manualBankRoutingNumber) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankRoutingNumber,
    manualBankRoutingNumberTouched: true,
  });

export const updateManualBankSimulationMode = (manualBankSimulationMode) =>
  createAction(UPDATE_MANUAL_BANK_FIELD)({
    manualBankSimulationMode,
  });

export const getFailureHistory = () => {
  return (dispatch) => {
    const action = createAction(RETREIVE_FAILURE_HISTORY)(
      callApi(getEndpoint('bankFailure'))
    );
    dispatch(action).catch((error) => console.error(error));
  };
};

export const validateRoutingNumber = (payload) => {
  const options = {
    method: 'POST',
  };
  const data = {
    '@Type': 'BankAgreementKey',
    routingNumber: payload,
  };
  return (dispatch) => {
    const action = createAction(VALIDATE_ROUTING_NUMBER)(
      callApi(
        getEndpoint('validateRoutingNumber'),
        options,
        JSON.stringify(data)
      )
    );
    dispatch(action);
  };
};

export const resetRoutingNumberValidation = () => {
  return (dispatch) => {
    const action = createAction(RESET_VALIDATE_ROUTING_NUMBER)();
    dispatch(action);
  };
};
